import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(null);
  const reduce = useReducedMotion();
  return <div className="border-t border-gold/30" data-id="element-7" data-mp="39s6lww6vx6qe">
      {faqs.map((item, i) => {
      const isOpen = open === i;
      const panelId = `faq-panel-${i}`;
      const buttonId = `faq-button-${i}`;
      return <div key={item.q} className="border-b border-gold/30" data-id="element-8" data-mp="3ijysuwwp9xq8" data-mpi={i}>
            <h3 data-id="element-9" data-mp="1d6hlxua7cyv">
              <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-10" data-mp="1cwnby27ejnd">
                <span className="font-serif text-[1.45rem] leading-snug text-ivory md:text-2xl" data-id="element-11" data-mp="3cgosxsmkvwmg">{item.q}</span>
                <PlusIcon aria-hidden="true" strokeWidth={1.25} className={`h-6 w-6 shrink-0 text-gold transition-transform duration-200 ease-out-strong ${isOpen ? 'rotate-45' : ''}`} data-id="element-12" data-mp="3giab9thvt341" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-13" data-mp="3v5bw25l72bxe">
              {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduce ? false : {
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={reduce ? {
            opacity: 0
          } : {
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-14" data-mp="3zkh82cvalpw">
                  <p className="pb-6 pr-10 text-base leading-relaxed text-ivory/85" data-id="element-15" data-mp="3i312m3hukjvn">{item.a}</p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}